import Button from "@mui/material/Button";
import { Link } from "react-router";

import { ROUTES } from "~components/routeDefinitions.ts";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import type { Tenant } from "~generated";
import { subTranslationVars } from "~lib/stringHelpers.ts";

import styles from "./ErrorPages.module.scss";

interface TenantForbiddenProps {
  redirectToTenant: Tenant;
  forbiddenTenantName?: string;
}

export function TenantForbidden({
  redirectToTenant,
  forbiddenTenantName,
}: TenantForbiddenProps) {
  const t = useTranslation();

  const headerText = t.tenantForbiddenHeader.replace(
    "{forbiddenTenantName}",
    forbiddenTenantName || "",
  );

  const bodyText = subTranslationVars(
    t.tenantForbiddenText,
    {
      forbiddenTenantName: forbiddenTenantName || "",
      allowedTenantName: redirectToTenant.name,
    },
    { escapeHtml: true },
  );

  const linkText = t.tenantForbiddenLink.replace(
    "{allowedTenantName}",
    redirectToTenant.name,
  );

  return (
    <div className={styles.container}>
      <h1>{headerText}</h1>
      <div>
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: interpolated values HTML-escaped via subTranslationVars */}
        <p dangerouslySetInnerHTML={{ __html: bodyText }} />
        <p>
          <Link
            to={ROUTES.dashboard.link({
              tenantNumber: redirectToTenant.number,
            })}
          >
            <Button>{linkText}</Button>
          </Link>
        </p>
        <p className={styles.contacts}>{t.forbiddenFooter}</p>
      </div>
    </div>
  );
}
